export const CashRegisters = {
  en: {
    'Cash Registers': 'Cash Registers',
    'Create Cash Register': 'Create Cash Register',
    Location: 'Location',
    'Legal Entity': 'Legal Entity',
    Kind: 'Kind',
    'Initial Balance': 'Initial Balance',
    'Current Balance': 'Current Balance',
    Cash: 'Cash',
    Cashless: 'Cashless',
    Safe: 'Safe',
    Personal: 'Personal',
    Bank: 'Bank',
    'Card Account': 'Card Account',
    'Grey (no legal entity)': 'Grey (no legal entity)',
  },
  uk: {
    'Cash Registers': 'Каси',
    'Create Cash Register': 'Створити касу',
    Location: 'Локація',
    'Legal Entity': 'Юридична особа',
    Kind: 'Тип',
    'Initial Balance': 'Початковий баланс',
    'Current Balance': 'Поточний баланс',
    Cash: 'Готівка',
    Cashless: 'Термінал',
    Safe: 'Сейф',
    Personal: 'Персональна каса',
    Bank: 'Банківський рахунок',
    'Card Account': 'Картковий рахунок',
    'Grey (no legal entity)': 'Сіра (без юридичної особи)',
  },
};

export const CashRegisterForm = {
  en: {
    ...CashRegisters.en,
    'Cash Register': 'Cash Register',
    'New Cash Register': 'New Cash Register',
    'Edit Cash Register': 'Edit Cash Register',
    'Update Cash Register': 'Update Cash Register',
  },
  uk: {
    ...CashRegisters.uk,
    'Cash Register': 'Каса',
    'New Cash Register': 'Нова каса',
    'Edit Cash Register': 'Редагування каси',
    'Update Cash Register': 'Оновити касу',
  },
};
